import type {DocumentCatalog, DocumentTypeCatalog} from './types';

export const DOCUMENT_CATALOG: DocumentCatalog = {
  AD: {
    passport: {side: 'data', image: 'AD-passport-prado', mrz: [4.6, 80.6, 90.5, 12.7]},
  },
  AE: {
    id: {side: 'back', image: 'AE-id-back', other: 'AE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'AE-passport', mrz: [3, 76, 94, 17]},
  },
  AF: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  AG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  AL: {
    id: {side: 'back', image: 'AL-id-back', other: 'AL-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'AL-passport', mrz: [3, 76, 94, 17]},
  },
  AM: {
    passport: {side: 'data', image: 'AM-passport-prado', mrz: [4.4, 79.6, 90.2, 13.5]},
  },
  AO: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  AR: {
    id: {side: 'back', image: 'AR-id-back', other: 'AR-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'AR-passport', mrz: [3, 76, 94, 17]},
  },
  AT: {
    id: {side: 'back', image: 'AT-id-back', other: 'AT-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'AT-passport', mrz: [3, 76, 94, 17]},
  },
  AU: {
    passport: {side: 'data', image: 'AU-passport', mrz: [3, 76, 94, 17]},
  },
  AZ: {
    passport: {side: 'data', image: 'AZ-passport', mrz: [3, 76, 94, 17]},
  },
  BA: {
    id: {side: 'back', image: 'BA-id-back', other: 'BA-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'BA-passport', mrz: [3, 76, 94, 17]},
  },
  BB: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BD: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BE: {
    id: {side: 'back', image: 'BE-id-back', other: 'BE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'BE-passport', mrz: [3, 76, 94, 17]},
  },
  BF: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BG: {
    id: {side: 'back', image: 'BG-id-back', other: 'BG-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'BG-passport', mrz: [3, 76, 94, 17]},
  },
  BH: {
    id: {side: 'back', image: 'BH-id-back', other: 'BH-id-front', mrz: [5.5, 74, 87, 22]},
    passport: {side: 'data', image: 'BH-passport-prado', mrz: [3.5, 77.3, 92.6, 13]},
  },
  BI: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BJ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BN: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BO: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BR: {
    id: {side: 'back', image: 'BR-id-back', other: 'BR-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'BR-passport', mrz: [3, 76, 94, 17]},
  },
  BS: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BT: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BW: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  BY: {
    id: {side: 'back', image: 'BY-id-back', other: 'BY-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'BY-passport', mrz: [3, 76, 94, 17]},
  },
  BZ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CA: {
    passport: {side: 'data', image: 'CA-passport', mrz: [3, 76, 94, 17]},
  },
  CD: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CF: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CH: {
    id: {side: 'back', image: 'CH-id-back', other: 'CH-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'CH-passport', mrz: [3, 76, 94, 17]},
  },
  CI: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CL: {
    id: {side: 'back', image: 'CL-id-back', other: 'CL-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'CL-passport', mrz: [3, 76, 94, 17]},
  },
  CM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CN: {
    passport: {side: 'data', image: 'CN-passport', mrz: [3, 76, 94, 17]},
  },
  CO: {
    id: {side: 'back', image: 'CO-id-back', other: 'CO-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'CO-passport', mrz: [3, 76, 94, 17]},
  },
  CR: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'CR-passport-prado', mrz: [4.7, 77.3, 90.6, 13.7]},
  },
  CU: {
    passport: {side: 'data', image: 'CU-passport-prado', mrz: [3.3, 78.4, 94, 14.2]},
  },
  CV: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  CY: {
    id: {side: 'back', image: 'CY-id-back', other: 'CY-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'CY-passport', mrz: [3, 76, 94, 17]},
  },
  CZ: {
    id: {side: 'back', image: 'CZ-id-back', other: 'CZ-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'CZ-passport', mrz: [3, 76, 94, 17]},
  },
  DE: {
    id: {side: 'back', image: 'DE-id-back', other: 'DE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'DE-passport', mrz: [3, 76, 94, 17]},
  },
  DJ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  DK: {
    passport: {side: 'data', image: 'DK-passport', mrz: [3, 76, 94, 17]},
  },
  DM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  DO: {
    passport: {side: 'data', image: 'DO-passport-prado', mrz: [3.6, 82.3, 91, 13.2]},
  },
  DZ: {
    id: {side: 'back', image: 'DZ-id-back', other: 'DZ-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'DZ-passport', mrz: [3, 76, 94, 17]},
  },
  EC: {
    id: {
      side: 'back',
      image: 'EC-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'EC-passport-prado', mrz: [4.3, 80.2, 90.8, 13.8]},
  },
  EE: {
    id: {side: 'back', image: 'EE-id-back', other: 'EE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'EE-passport', mrz: [3, 76, 94, 17]},
  },
  EG: {
    passport: {side: 'data', image: 'EG-passport-prado', mrz: [4.5, 79.1, 91.2, 13.6]},
  },
  ER: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  ES: {
    id: {side: 'back', image: 'ES-id-back', other: 'ES-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'ES-passport', mrz: [3, 76, 94, 17]},
  },
  ET: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  FI: {
    id: {side: 'back', image: 'FI-id-back', other: 'FI-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'FI-passport', mrz: [3, 76, 94, 17]},
  },
  FJ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  FM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  FR: {
    id: {side: 'back', image: 'FR-id-back', other: 'FR-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'FR-passport', mrz: [3, 76, 94, 17]},
  },
  GA: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GB: {
    passport: {side: 'data', image: 'GB-passport', mrz: [3, 76, 94, 17]},
  },
  GD: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GE: {
    id: {side: 'back', image: 'GE-id-back', other: 'GE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'GE-passport', mrz: [3, 76, 94, 17]},
  },
  GH: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GN: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GQ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GR: {
    id: {side: 'back', image: 'GR-id-back', other: 'GR-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'GR-passport', mrz: [3, 76, 94, 17]},
  },
  GT: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GW: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  GY: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  HN: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  HR: {
    id: {side: 'back', image: 'HR-id-back', other: 'HR-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'HR-passport', mrz: [3, 76, 94, 17]},
  },
  HT: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  HU: {
    id: {side: 'back', image: 'HU-id-back', other: 'HU-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'HU-passport', mrz: [3, 76, 94, 17]},
  },
  ID: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  IE: {
    passport: {side: 'data', image: 'IE-passport', mrz: [3, 76, 94, 17]},
  },
  IL: {
    passport: {side: 'data', image: 'IL-passport', mrz: [3, 76, 94, 17]},
  },
  IN: {
    passport: {side: 'data', image: 'IN-passport', mrz: [3, 76, 94, 17]},
  },
  IQ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  IR: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  IS: {
    id: {side: 'back', image: 'IS-id-back', other: 'IS-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'IS-passport', mrz: [3, 76, 94, 17]},
  },
  IT: {
    id: {side: 'back', image: 'IT-id-back', other: 'IT-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'IT-passport', mrz: [3, 76, 94, 17]},
  },
  JM: {
    passport: {side: 'data', image: 'JM-passport-prado', mrz: [4.8, 76.9, 91.6, 14.5]},
  },
  JO: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  JP: {
    passport: {side: 'data', image: 'JP-passport', mrz: [3, 76, 94, 17]},
  },
  KE: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  KG: {
    passport: {side: 'data', image: 'KG-passport-prado', mrz: [4, 77.1, 91, 13.4]},
  },
  KH: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  KI: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  KM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  KN: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  KP: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  KR: {
    passport: {side: 'data', image: 'KR-passport', mrz: [3, 76, 94, 17]},
  },
  KW: {
    passport: {side: 'data', image: 'KW-passport-prado', mrz: [0.3, 79, 94.7, 11.6]},
  },
  KZ: {
    passport: {side: 'data', image: 'KZ-passport-prado', mrz: [4.7, 76.1, 89.5, 14.2]},
  },
  LA: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  LB: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  LC: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  LI: {
    id: {side: 'back', image: 'LI-id-back', other: 'LI-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'LI-passport', mrz: [3, 76, 94, 17]},
  },
  LK: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  LR: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  LS: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  LT: {
    id: {side: 'back', image: 'LT-id-back', other: 'LT-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'LT-passport', mrz: [3, 76, 94, 17]},
  },
  LU: {
    id: {side: 'back', image: 'LU-id-back', other: 'LU-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'LU-passport', mrz: [3, 76, 94, 17]},
  },
  LV: {
    id: {side: 'back', image: 'LV-id-back', other: 'LV-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'LV-passport', mrz: [3, 76, 94, 17]},
  },
  LY: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MA: {
    id: {side: 'back', image: 'MA-id-back', other: 'MA-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'MA-passport', mrz: [3, 76, 94, 17]},
  },
  MC: {
    id: {side: 'back', image: 'MC-id-back', other: 'MC-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'MC-passport', mrz: [3, 76, 94, 17]},
  },
  MD: {
    id: {side: 'back', image: 'MD-id-back', other: 'MD-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'MD-passport', mrz: [3, 76, 94, 17]},
  },
  ME: {
    id: {side: 'back', image: 'ME-id-back', other: 'ME-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'ME-passport', mrz: [3, 76, 94, 17]},
  },
  MG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MH: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MK: {
    id: {side: 'back', image: 'MK-id-back', other: 'MK-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'MK-passport', mrz: [3, 76, 94, 17]},
  },
  ML: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MN: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MR: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MT: {
    id: {side: 'back', image: 'MT-id-back', other: 'MT-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'MT-passport', mrz: [3, 76, 94, 17]},
  },
  MU: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MV: {
    passport: {side: 'data', image: 'MV-passport-prado', mrz: [2.7, 80.3, 92.7, 14.2]},
  },
  MW: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  MX: {
    id: {side: 'back', image: 'MX-id-back', other: 'MX-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'MX-passport', mrz: [3, 76, 94, 17]},
  },
  MY: {
    passport: {side: 'data', image: 'MY-passport', mrz: [3, 76, 94, 17]},
  },
  MZ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  NA: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  NE: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  NG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  NI: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  NL: {
    id: {side: 'back', image: 'NL-id-back', other: 'NL-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'NL-passport', mrz: [3, 76, 94, 17]},
  },
  NO: {
    id: {side: 'back', image: 'NO-id-back', other: 'NO-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'NO-passport', mrz: [3, 76, 94, 17]},
  },
  NP: {
    passport: {side: 'data', image: 'NP-passport-prado', mrz: [3.2, 80.9, 92, 13.2]},
  },
  NR: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  NZ: {
    passport: {side: 'data', image: 'NZ-passport-prado', mrz: [2.9, 78.3, 92.7, 13.8]},
  },
  OM: {
    passport: {side: 'data', image: 'OM-passport-prado', mrz: [3.7, 79.3, 90.7, 13.2]},
  },
  PA: {
    passport: {side: 'data', image: 'PA-passport-prado', mrz: [4.2, 79.6, 92.6, 13.5]},
  },
  PE: {
    id: {side: 'back', image: 'PE-id-back', other: 'PE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'PE-passport', mrz: [3, 76, 94, 17]},
  },
  PG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  PH: {
    passport: {side: 'data', image: 'PH-passport-prado', mrz: [4.3, 79.9, 91.2, 13.9]},
  },
  PK: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  PL: {
    id: {side: 'back', image: 'PL-id-back', other: 'PL-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'PL-passport', mrz: [3, 76, 94, 17]},
  },
  PS: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  PT: {
    id: {side: 'back', image: 'PT-id-back', other: 'PT-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'PT-passport', mrz: [3, 76, 94, 17]},
  },
  PW: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  PY: {
    passport: {side: 'data', image: 'PY-passport-prado', mrz: [3.3, 78.1, 91.3, 14.3]},
  },
  QA: {
    passport: {side: 'data', image: 'QA-passport-prado', mrz: [4.2, 79.4, 89, 12.9]},
  },
  RO: {
    id: {side: 'back', image: 'RO-id-back', other: 'RO-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'RO-passport', mrz: [3, 76, 94, 17]},
  },
  RS: {
    id: {side: 'back', image: 'RS-id-back', other: 'RS-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'RS-passport', mrz: [3, 76, 94, 17]},
  },
  RU: {
    passport: {side: 'data', image: 'RU-passport', mrz: [3, 76, 94, 17]},
  },
  RW: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SA: {
    passport: {side: 'data', image: 'SA-passport-prado', mrz: [4, 76, 90.8, 13]},
  },
  SB: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SC: {
    passport: {side: 'data', image: 'SC-passport-prado', mrz: [2.7, 83, 92, 14.6]},
  },
  SD: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SE: {
    id: {side: 'back', image: 'SE-id-back', other: 'SE-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'SE-passport', mrz: [3, 76, 94, 17]},
  },
  SG: {
    passport: {side: 'data', image: 'SG-passport-prado', mrz: [5.6, 77.4, 87.8, 13.8]},
  },
  SI: {
    id: {side: 'back', image: 'SI-id-back', other: 'SI-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'SI-passport', mrz: [3, 76, 94, 17]},
  },
  SK: {
    id: {side: 'back', image: 'SK-id-back', other: 'SK-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'SK-passport', mrz: [3, 76, 94, 17]},
  },
  SL: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SM: {
    id: {side: 'back', image: 'SM-id-back', other: 'SM-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'SM-passport-prado', mrz: [4.6, 80.2, 89.1, 13]},
  },
  SN: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SO: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SR: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SS: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  ST: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SV: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SY: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  SZ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TD: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TH: {
    passport: {side: 'data', image: 'TH-passport', mrz: [3, 76, 94, 17]},
  },
  TJ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TL: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TN: {
    passport: {side: 'data', image: 'TN-passport', mrz: [3, 76, 94, 17]},
  },
  TO: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TR: {
    id: {side: 'back', image: 'TR-id-back', other: 'TR-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'TR-passport', mrz: [3, 76, 94, 17]},
  },
  TT: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TV: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  TZ: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  UA: {
    id: {side: 'back', image: 'UA-id-back', other: 'UA-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'UA-passport', mrz: [3, 76, 94, 17]},
  },
  UG: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  US: {
    passport: {side: 'data', image: 'US-passport', mrz: [3, 76, 94, 17]},
  },
  UY: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'UY-passport-prado', mrz: [3, 80.6, 92.1, 14]},
  },
  UZ: {
    passport: {side: 'data', image: 'UZ-passport-prado', mrz: [5.3, 78.8, 90.5, 13.9]},
  },
  VA: {
    passport: {side: 'data', image: 'VA-passport', mrz: [3, 76, 94, 17]},
  },
  VC: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  VE: {
    passport: {side: 'data', image: 'VE-passport-prado', mrz: [2, 78, 93.9, 14.2]},
  },
  VN: {
    id: {
      side: 'back',
      image: 'generic-id-back',
      other: 'generic-id-front',
      mrz: [4, 62, 92, 28],
    },
    passport: {side: 'data', image: 'VN-passport-prado', mrz: [5.2, 82.3, 91.2, 12.9]},
  },
  VU: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  WS: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  XK: {
    id: {side: 'back', image: 'XK-id-back', other: 'XK-id-front', mrz: [4, 62, 92, 28]},
    passport: {side: 'data', image: 'XK-passport', mrz: [3, 76, 94, 17]},
  },
  YE: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  ZA: {
    passport: {side: 'data', image: 'ZA-passport-prado', mrz: [3.2, 79.3, 91.9, 13.9]},
  },
  ZM: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
  ZW: {
    passport: {side: 'data', image: 'generic-passport', mrz: [3, 76, 94, 17]},
  },
};

export const DOCUMENT_TYPE_CATALOG: DocumentTypeCatalog = {
  AE_RP: {
    kind: 'id',
    side: 'back',
    image: 'AE-id-back',
    other: 'AE-id-front',
    mrz: [4, 62, 92, 28],
  },
  AT_O: {
    kind: 'id',
    side: 'lines',
    image: 'generic-id-back',
    other: 'generic-id-front',
    mrz: [4, 62, 92, 28],
  },
  CA_DL: {
    kind: 'driving_license',
    side: 'back',
    image: 'US-dl-back',
    other: 'US-dl-front',
    mrz: [34, 11, 53, 32],
  },
  CO_FID: {
    kind: 'id',
    side: 'back',
    image: 'CO-cedula-back',
    other: 'CO-cedula-front',
    mrz: [4.5, 64.7, 90.7, 26.1],
  },
  ES_N: {
    kind: 'id',
    side: 'back',
    image: 'ES-tie-back',
    other: 'ES-tie-front',
    mrz: [5.4, 66.7, 90, 23.4],
  },
  ES_X: {
    kind: 'id',
    side: 'back',
    image: 'ES-tie-back',
    other: 'ES-tie-front',
    mrz: [5.4, 66.7, 90, 23.4],
  },
  FR_IDENT: {
    kind: 'id',
    side: 'front',
    image: 'FR-id-paper-front',
    mrz: [5.8, 75.1, 86.2, 16.1],
  },
  PT_O: {
    kind: 'id',
    side: 'lines',
    image: 'generic-id-back',
    other: 'generic-id-front',
    mrz: [4, 62, 92, 28],
  },
  RO_ID_NEW: {
    kind: 'id',
    side: 'back',
    image: 'RO-id-back',
    other: 'RO-id-front',
    mrz: [4, 62, 92, 28],
  },
  RO_ID_OLD: {
    kind: 'id',
    side: 'front',
    image: 'RO-id-classic-front',
    mrz: [3.9, 75.3, 90, 14.6],
  },
  US_DL: {
    kind: 'driving_license',
    side: 'back',
    image: 'US-dl-back',
    other: 'US-dl-front',
    mrz: [34, 11, 53, 32],
  },
};
